import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";
import { COLLECTIONS } from "../lib/site";

export default function Collections() {
    return (
        <div data-testid="page-collections" className="pt-32">
            <Seo
                title="Collections — Bed & Bath Linen"
                description="Bed linen manufacturers in India · Blanket manufacturers in India · Bedsheet, duvet, pillow cover, table linen, quilt and bath towel manufacturer. Six Vyom collections in 100% cotton, 100% linen and blends of viscose, polyester, tencel, modal and bamboo."
                path="/collections"
            />
            <section className="container-vyom pb-16 md:pb-24">
                <Reveal>
                    <div className="text-[17.5px] uppercase tracking-overline text-vyom-mute mb-8">
                        The Collections
                    </div>
                </Reveal>
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end">
                    <div className="md:col-span-7">
                        <Reveal delay={0.05}>
                            <h1 className="font-serif-display text-5xl md:text-7xl lg:text-[104px] leading-[0.98] tracking-tight">
                                Six collections,{" "}
                                <span className="italic">
                                    one
                                </span>{" "}
                                standard.
                            </h1>
                        </Reveal>
                    </div>
                    <div className="md:col-span-4 md:col-start-9">
                        <Reveal delay={0.15}>
                            <p className="text-[19px] leading-relaxed text-vyom-mute max-w-md">
                                We make linen across every register — from
                                100% cotton and 100% linen to refined blends
                                of viscose, polyester, tencel, modal, bamboo,
                                and beyond. Each piece is built to soften
                                with use, not wear with it.
                            </p>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section
                data-testid="materials-band"
                className="border-y border-vyom-rule bg-vyom-bg2/40"
            >
                <div className="container-vyom py-14 md:py-20">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-start">
                        <div className="md:col-span-3">
                            <Reveal>
                                <div className="text-[17.5px] uppercase tracking-overline text-vyom-mute">
                                    Materials
                                </div>
                            </Reveal>
                        </div>
                        <div className="md:col-span-9">
                            <Reveal delay={0.08}>
                                <div className="font-serif-display text-3xl md:text-4xl lg:text-[44px] leading-[1.15] tracking-tight max-w-4xl">
                                    100% Cotton.{" "}
                                    <span className="italic">100% Linen.</span>{" "}
                                    Considered blends of viscose, polyester,
                                    tencel, modal, bamboo —{" "}
                                    <span className="italic">and more</span>.
                                </div>
                                <p className="mt-8 text-[19px] leading-[1.8] text-vyom-mute max-w-2xl">
                                    Every fibre is chosen for hand, drape, and
                                    longevity. We mill, weave, and finish to
                                    your house's specification — from
                                    everyday programs to bespoke editions.
                                </p>
                            </Reveal>
                        </div>
                    </div>
                </div>
            </section>

            <section className="border-t border-vyom-rule">
                <div className="container-vyom section-pad space-y-24 md:space-y-32">
                    {COLLECTIONS.map((c, i) => {
                        const reverse = i % 2 === 1;
                        return (
                            <article
                                key={c.slug}
                                data-testid={`collection-row-${c.slug}`}
                                className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center"
                            >
                                <div
                                    className={`md:col-span-7 ${
                                        reverse ? "md:order-2" : ""
                                    }`}
                                >
                                    <Reveal>
                                        <div className="overflow-hidden aspect-[4/3] bg-vyom-bg2">
                                            <img
                                                src={c.image}
                                                alt={c.title}
                                                loading="lazy"
                                                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1400ms] ease-out"
                                            />
                                        </div>
                                    </Reveal>
                                </div>
                                <div
                                    className={`md:col-span-4 ${
                                        reverse
                                            ? "md:order-1 md:col-start-1"
                                            : "md:col-start-9"
                                    }`}
                                >
                                    <Reveal delay={0.1}>
                                        <div className="text-[17.5px] uppercase tracking-overline text-vyom-mute mb-5">
                                            0{i + 1} — Collection
                                        </div>
                                        <h2 className="font-serif-display text-4xl md:text-5xl leading-tight tracking-tight">
                                            {c.title}
                                        </h2>
                                        <p className="mt-6 text-[19.5px] leading-[1.8] text-vyom-mute max-w-md">
                                            {c.copy}
                                        </p>
                                        <div className="mt-10">
                                            <Link
                                                to="/contact"
                                                data-testid={`collection-inquire-${c.slug}`}
                                                className="text-[19px] whitespace-nowrap uppercase tracking-overline text-vyom-ink link-underline"
                                            >
                                                Inquire about {c.title}
                                            </Link>
                                        </div>
                                    </Reveal>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </section>
        </div>
    );
}
